import { render, staticRenderFns } from "./Policies.vue?vue&type=template&id=56629654&scoped=true"
import script from "./Policies.vue?vue&type=script&setup=true&lang=ts"
export * from "./Policies.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56629654",
  null
  
)

export default component.exports